import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SectionHeader } from '../SectionHeader';
import { GlassCard } from '../GlassCard';

interface SettingsSectionProps {
  title: string;
  /** Wrap children in a GlassCard (used for Notifications and Privacy) */
  useCard?: boolean;
  /** Use dim title color for less prominent sections like Account Actions */
  dimTitle?: boolean;
  children: React.ReactNode;
}

export const SettingsSection: React.FC<SettingsSectionProps> = React.memo(({
  title,
  useCard = false,
  dimTitle = false,
  children,
}) => (
  <View>
    <View style={dimTitle ? styles.dimHeaderContainer : undefined}>
      <SectionHeader title={title} />
    </View>
    {useCard ? (
      <GlassCard borderRadius={16} padding={0}>
        <View style={styles.cardInner}>
          {children}
        </View>
      </GlassCard>
    ) : (
      children
    )}
  </View>
));

SettingsSection.displayName = 'SettingsSection';

const styles = StyleSheet.create({
  dimHeaderContainer: {
    opacity: 0.7,
  },
  cardInner: {
    paddingHorizontal: 19,
    paddingTop: 5,
    paddingBottom: 1,
  },
});
